<template>
	<div class="notice">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onadd()">新增公告</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="">
						<el-input v-model="formfilter.name" placeholder="标题"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.state" placeholder="状态">
							<el-option label="状态" value=""></el-option>
							<el-option label="启用" :value="1"></el-option>
							<el-option label="禁用" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="name" label="标题" align="left" header-align="center" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="create_time_str" label="日期" align="center" header-align="center" width="160px">
					</el-table-column>
					<el-table-column prop="shop_id_str" label="渠道" align="center" header-align="center">
					</el-table-column>
					<el-table-column label="展示" align="center" header-align="center" width="80px">
						<template slot-scope="scope">
							<div v-if="scope.row.show_type == 1">买家展示</div>
							<div v-if="scope.row.show_type == 2">卖家展示</div>
							<div v-if="scope.row.show_type == 3">全部展示</div>
						</template>
					</el-table-column>
					<el-table-column prop="view_num" label="点击数" align="center" header-align="center" width="80px">
					</el-table-column>
					<el-table-column label="状态" align="center" header-align="center" width="80px">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.state" :active-value="1" :inactive-value="2" @change="onswitch(scope.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="weight" label="排序" align="center" header-align="center" width="80px">
					</el-table-column>
					<el-table-column label="操作" align="center" header-align="center" width="110px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="onupdate(scope.row)">编辑</span>
								<span @click="ondelete(scope.row)">删除</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>

		<el-dialog title="公告编辑" :visible.sync="show" width="800px" :before-close="onclose">
			<div class="forms" v-if="show">
				<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="60px">
					<el-form-item label="标题" prop="name" class="item">
						<el-input v-model="ruleForm.name" placeholder="请填写标题"></el-input>
					</el-form-item>
					<el-form-item label="内容" prop="content" class="item">
						<rich-text :values.sync="ruleForm.content"></rich-text>
					</el-form-item>
					<el-form-item label="渠道" prop="shop_id" class="item">
						<el-select v-model="ruleForm.shop_id" placeholder="请选择渠道" multiple collapse-tags>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="展示" prop="show_type" class="item">
						<el-radio-group v-model="ruleForm.show_type">
							<el-radio :label="1">买家展示</el-radio>
							<el-radio :label="2">卖家展示</el-radio>
							<el-radio :label="3">全部展示</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="状态" prop="state" class="item">
						<el-switch v-model="ruleForm.state" :active-value="1" :inactive-value="2"></el-switch>
					</el-form-item>
					<el-form-item label="排序" prop="weight" class="item">
						<el-input v-model.number="ruleForm.weight" placeholder="请输入排序"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose">取消</el-button>
				<el-button type="primary" @click="onsub()">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Notice',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				qudao: [],
				formfilter: {
					name: "",
					state: "",

				},

				ruleForm: {
					id: "",
					name: "",
					shop_id: [],
					show_type: "",
					state: 1,
					content: ""
				},

				rules: {
					name: [{
						required: true,
						message: '请输入标题',
						trigger: 'blur'
					}],
					
					shop_id: [{
						required: true,
						message: '请选择渠道',
						trigger: 'change'
					}],
					
					content: [{
						required: true,
						message: '请输入内容',
						trigger: 'blur'
					}],
					
					show_type: [{
						required: true,
						message: '请设置公告在页面中的展示',
						trigger: 'change'
					}],
				},

				filtershow: true,
				show: false,
			}
		},

		mounted() {
			this.onlist();
			this.onqudao();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},

		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},

		methods: {
			handleCurrentChange() {
				this.onlist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},

			onfilter() {
				this.page = 1;
				this.onlist();
			},

			onreset() {
				this.formfilter = {
					id: "",
					name: "",
					state: ""
				};
				this.page = 1;
				this.onlist();
			},

			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				obj.limit = this.pageSize;

				this.$axios.post('api/user/user_notice_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onqudao() {
				var obj = {
					code: "",
					name: "",
					state: 2,
					page: 1,
					limit: 99999
				};

				this.$axios.post('api/user/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.qudao = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onadd() {
				this.show = true;
			},

			onclose() {
				this.show = false;
				this.ruleForm = {
					id: "",
					name: "",
					shop_id: [],
					content: "",
					show_type: "",
					state: 1,
				};
			},
			
			onupdate(data) {
				var obj = {
					id: data.id
				};
				
				this.$axios.post('api/user/user_notice_list', obj).then(res => {
					if (res.data.code == 0) {
						var data = res.data.data.list[0];
						console.log(data);
						for (let key in this.ruleForm) {
							if (key == 'shop_id') {
								this.ruleForm[key] = data[key].split(',').map(Number);
							} else {
								this.ruleForm[key] = data[key];
							}
						}
						this.show = true;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm));
						obj.shop_id = obj.shop_id.join(',');
						this.$axios.post('/api/user/user_notice_save', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose();
								this.onlist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},
			
			onswitch(data) {
				var obj = {
					id: data.id,
					state: data.state,
				};
				this.$axios.post('/api/user/user_notice_state', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('操作成功');
						this.onlist();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			ondelete(o) {
				this.$confirm('是否删除该条公告, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						ids: o.id
					}
					this.$axios.post('api/user/user_notice_delete', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('操作成功');
							this.onlist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			}
		}
	}
</script>

<style scoped lang="less">
	.notice {
		height: 100%;
	}

	.tablebox {
		height: calc(100% - 104px);
	}
	
	/deep/ .item .el-select {
		width: 400px;
	}
	
	/deep/ .item .el-input {
		width: 400px;
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/notice.vue